define([
    './module',

    './scripts/commentsModal.service'
], function(MODULE_NAME){
   return MODULE_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-comments/main.js
// module id = 16
// module chunks = 0